import React, {
  ChangeEvent,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { connect } from "react-redux";
import { DropdownToggle } from "reactstrap";
import { DropdownMenu } from "reactstrap";
import { Dropdown } from "reactstrap";
import { Button } from "reactstrap";
import {
  Field,
  getFormValues,
  InjectedFormProps,
  reduxForm,
  reset,
} from "redux-form";
import { TextField } from "common-fields";
import MessageDisplayBox from "./MessageDisplayBox";
import { ReactComponent as MenuIcon } from "../../images/MessageCenter/3-dots-menu.svg";
import { ReactComponent as SendIcon } from "../../images/MessageCenter/send-triangle.svg";
import { ReactComponent as PDFIcon } from "../../images/MessageCenter/pdf.svg";
import { ReactComponent as DeleteCross } from "../../images/MessageCenter/delete-cross.svg";
import { AxiosError, AxiosResponse } from "axios";
import { Modal, ModalHeader, Row, Col, ModalBody } from "reactstrap";
// import FileViewer from "react-file-viewer";
import validate from "../../Validate/Validate";
import DropdownItem from "react-bootstrap/esm/DropdownItem";
import { toast } from "react-toastify";
import {
  IReloadMessageComponentModel,
  MessageThreadModel,
  UserModel,
  postMessageData,
  postMessageThreadData,
} from "../../models/MessageCenterModels";
import Service from "../../services";
import { catchError } from "../../utils/Utils";
import ReactDropdownTreeSelect from "../../commonfields/ReactDropdownTreeSelect";
import TextFieldNew from "../../commonfields/TextFieldNew";
import FileUploadWithoutViewer from "../../commonfields/FileUploadWithoutViewer";
import { getFinRecipientValues } from "../../data/MessageCenter";
import FinSpinner from "../../commonfields/FinSpinner";
import { catchErrorGeneric } from "../../utils/GeneralUtils";
import ReactFileViewer from "../../commonfields/ReactFileViewer";
import { useLocation } from "react-router-dom";

interface MessageFormProps {
  config: any;
  conversation: MessageThreadModel | undefined;
  setConversation: React.Dispatch<
    React.SetStateAction<MessageThreadModel | undefined>
  >;
  bankuserDetails: any;
  reload?: IReloadMessageComponentModel;
  setReload?: React.Dispatch<
    React.SetStateAction<IReloadMessageComponentModel>
  >;
}

const MessageForm: React.FC<
  MessageFormProps &
  InjectedFormProps<Record<string, unknown>, MessageFormProps>
> = (props: any) => {
  const service = useMemo(() => new Service(), []);
  const { config, reload, setReload } = props;

  // states //
  const [users, setUsers] = useState<UserModel[] | []>([]);
  const [recipientsMap, setRecipientsMap] = useState<any>();
  const [archiveDropdown, setArchiveDropdown] = useState(false);
  const [attachmentsFile, setAttachmentsFile] = useState<any>();
  const [downloadFile, setDownloadFile] = useState<any>();
  const [fileLoading, setFileLoading] = useState(false);
  const [viewFile, setViewFile] = useState(false);
  const [inList, setInList] = useState<boolean>(false);
  const [readMore, setReadMore] = useState(false);
  const [recipientValue, setRecipientValue] = useState<any>();
  const location = useLocation();
  console.log("location", location.pathname)

  const removeAllFiles = useRef<any>();
  const reloadMessages = useRef<any>();

  // handle functions //

  const handleArchiveDropdown = () => {
    setArchiveDropdown((prev) => !prev);
  };

  const removeFile = () => {
    setAttachmentsFile("");
    removeAllFiles?.current && removeAllFiles?.current();
  };

  /* get the id to whom the message has to be sent and to be displayed on dropdonw */
  const getValidSentToId = () => {
    return props?.bankuserDetails?.userId === props.conversation?.createdBy
      ? props?.conversation?.sentTo
      : props?.conversation?.createdBy;
  };

  /* Add lable and values for children data and if id matches mark as default */
  const getLabelValues = (arr: any, parent: string) =>
    arr.map((each: any) => {
      return {
        label: `${each?.firstName} ${each?.lastName}`,
        value: each?.userId,
        parent: parent,
      };
    });

  /* Convert the api response to react dropdown tree select data format */
  const getRecipientData = (data: any) => {
    let recipientDataList: any = [];
    if (data && data?.length > 0) {
      data.forEach((each: any) => {
        if (each?.user && each.user?.length > 0) {
          recipientDataList = [
            ...recipientDataList,
            {
              label: each?.role,
              children: getLabelValues(each?.user, each?.role),
            },
          ];
        }
      });
      return recipientDataList;
    } else {
      return recipientDataList;
    }
  };

  /* react dropdown select value change handle */
  const handleRecipient = (value: ChangeEvent<HTMLSelectElement>) => {
    setRecipientValue(value);
  };

  const getHelpTextForRecipient = () => {
    if (props?.conversation?.id) {
      return inList ? " " : "--";
    } else {
      return inList ? " " : "Enter Recipient";
    }
  };

  // apis //
  const handlePinClick = (e: any) => {
    if (props.conversation?.id) {
      service
        .updateThreadPinnedFlag(
          props.conversation.id,
          props.conversation?.pinnedFlag ? false : true
        )
        .then((res: AxiosResponse) => {
          if (res?.status === 200) {
            setReload && setReload({ ...reload, list: true });
            props?.setConversation(undefined);
          } else {
            // toast.error("Something went Wrong");
            catchErrorGeneric("Something went wrong");
          }
        })
        .catch((error: AxiosError) => {
          catchError(error, true);
        });
    }
    e.stopPropagation();
  };

  const updateThreadArchiveFlag = (e: any) => {
    if (props?.conversation?.id) {
      service
        .updateThreadArchiveFlag(
          props.conversation.id,
          props.conversation?.archiveFlag ? false : true
        )
        .then((res: AxiosResponse) => {
          if (res?.status === 200) {
            setReload && setReload({ ...reload, list: true });
            props?.setConversation(undefined);
          } else {
            // toast.error("Something went Wrong");
            catchErrorGeneric("Something went wrong");
          }
        })
        .catch((error: AxiosError) => {
          catchError(error, true);
        });
    }
    e.stopPropagation();
  };

  const handleMessageSubmit = (values: any) => {
    let payload = {};
    if (props?.conversation?.id) {
      payload = {
        id: props.conversation.id,
        message: {
          ...(!attachmentsFile && { message: values?.message }),
          ...(!attachmentsFile && { messageType: "text" }),
          createdBy: props?.bankuserDetails?.userId,
          sentTo: getValidSentToId(),
        },
      };
      if (attachmentsFile) {
        setFileLoading(true);
        service
          .postSaveAttachment(attachmentsFile?.[0], payload as postMessageData)
          .then((res: any) => {
            if (res?.status === 200) {
              setReload && setReload({ ...reload, list: true });
              props?.dispatch(reset("MessageForm"));
              reloadMessages.current();
              removeFile();
              setFileLoading(false);
            } else {
              if (res?.response?.data === "Invalid File Format") {
                toast.error(res?.response?.data);
              } else {
                // toast.error(`Something went wrong`);
                catchErrorGeneric("Something went wrong");
              }
              setFileLoading(false);
              removeFile();
            }
          })
          .catch((error: AxiosError) => {
            catchError(error, true);
            setFileLoading(false);
            removeFile();
          });
      } else {
        if (values?.message) {
          service
            .postSaveMessage(payload as postMessageData)
            .then((res: AxiosResponse) => {
              if (res?.status === 200) {
                setReload && setReload({ ...reload, list: true });
                props?.dispatch(reset("MessageForm"));
                reloadMessages.current();
              } else {
                // toast.error("Something Went Wrong");
                catchErrorGeneric("Something went wrong");
              }
            })
            .catch((error: AxiosError) => {
              catchError(error, true);
            });
        }
      }
    } else {
      payload = {
        // clientName: `${values?.recipient?.clientFirstName || ''} ${values?.recipient?.clientLastName || ''}`,
        // clientCompany: values?.recipient?.clientCompany || "",
        clientId: values?.recipient?.value,
        createdBy: props?.bankuserDetails?.userId,
        sentTo: values?.recipient?.value,
        subject: values?.subject,
        ...(!attachmentsFile && {
          message: {
            message: values?.message,
          },
        }),
      };
      if (attachmentsFile) {
        setFileLoading(true);
        service
          .postSaveAttachment(attachmentsFile?.[0], payload as postMessageData)
          .then((res: any) => {
            if (res?.status === 200) {
              setReload && setReload({ ...reload, list: true });
              props?.dispatch(reset("MessageForm"));
              setRecipientValue(null);
              reloadMessages.current();
              removeFile();
              setFileLoading(false);
            } else {
              if (res?.response?.data === "Invalid File Format") {
                toast.error(res?.response?.data);
              } else {
                // toast.error(`Something went wrong`);
                catchErrorGeneric("Something went wrong");
              }
              setFileLoading(false);
              removeFile();
            }
          })
          .catch((error: AxiosError) => {
            catchError(error, true);
            removeFile();
            setFileLoading(false);
          });
      } else {
        if (values?.message) {
          service
            .postSaveMessageThread(payload as postMessageThreadData)
            .then((res: AxiosResponse) => {
              if (res?.status === 200) {
                setReload && setReload({ ...reload, list: true });
                props?.dispatch(reset("MessageForm"));
                reloadMessages.current();
                setRecipientValue(null);
              } else {
                // toast.error("Something Went Wrong");
                catchErrorGeneric("Something went wrong");
              }
            })
            .catch((error: AxiosError) => {
              catchError(error, true);
            });
        }
      }
    }
  };

  const getFinRecipient = () => {
    service
      .getFinRecipient()
      .then((res: AxiosResponse<UserModel[]>) => {
        if (res?.data) {
          setUsers(res.data);
          const data = getRecipientData(res.data);
          setRecipientsMap(data);
        }
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      });
  };

  // useEffects //

  /* Set Recipient Data */
  useEffect(() => {
    getFinRecipient();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [service]);

  /*  On change in conversation or users list change the dropdown */
  useEffect(() => {
    if (props?.conversation?.id) {
      setRecipientValue(getValidSentToId());
    } else {
      setRecipientValue(null);
      setInList(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.conversation?.id, users]);

  useEffect(() => {
    removeFile();
  }, [props?.conversation]);

  return (
    <form
      onSubmit={props.handleSubmit(handleMessageSubmit)}
      className="messageForm"
    >
      <div className="messageDisplayPlanel">
        <div className="inputs">
          <div className="recipientInput">
            {config?.messageRecipient ? (
              <Field
                component={ReactDropdownTreeSelect}
                name="recipient"
                helpText={getHelpTextForRecipient()}
                options={recipientsMap}
                mode={"radioSelect"}
                disabled={!!props?.conversation?.id}
                onChange={(value: ChangeEvent<HTMLSelectElement>) =>
                  handleRecipient(value)
                }
                recipientValue={recipientValue}
                setInList={setInList}
              />
            ) : (
              <></>
            )}
            {config?.messageDropdown ? (
              <Dropdown isOpen={archiveDropdown} toggle={handleArchiveDropdown}>
                <DropdownToggle
                  tag="div"
                  className="archiveDropDown"
                  data-toggle="dropdown"
                  aria-expand={archiveDropdown}
                >
                  <MenuIcon className="archive-dropdown-image" />
                </DropdownToggle>
                <DropdownMenu right>
                  {config?.archive ? (
                    <DropdownItem
                      disabled={!props?.conversation?.id}
                      onClick={(e: any) => {
                        handleArchiveDropdown();
                        updateThreadArchiveFlag(e);
                      }}
                    >
                      {props?.conversation?.archiveFlag
                        ? "UnArchive Thread"
                        : "Archive Thread"}
                    </DropdownItem>
                  ) : (
                    <></>
                  )}
                  {config?.pin ? (
                    <DropdownItem
                      disabled={!props?.conversation?.id}
                      onClick={(e: any) => {
                        handleArchiveDropdown();
                        handlePinClick(e);
                      }}
                    >
                      {props?.conversation?.pinnedFlag
                        ? "UnPin Thread"
                        : "Pin Thread"}
                    </DropdownItem>
                  ) : (
                    <></>
                  )}
                </DropdownMenu>
              </Dropdown>
            ) : (
              <></>
            )}
          </div>
          {config?.messageSubject ? (
            <div className="subjectInput">
              <span className="subjectInline">Subject: </span>
              <Field
                component={TextField}
                name="subject"
                type="text"
                disabled={!!props?.conversation?.subject}
              />
            </div>
          ) : (
            <></>
          )}
        </div>

        {config?.displayMessages ? (
          <MessageDisplayBox
            conversation={props?.conversation}
            setDownloadFile={setDownloadFile}
            setViewFile={setViewFile}
            setFileLoading={setFileLoading}
            users={users}
            reloadMessages={reloadMessages}
          />
        ) : (
          <></>
        )}

        {fileLoading ? <FinSpinner /> : <></>}
        {attachmentsFile && attachmentsFile?.length > 0 && (
          <div className="fileView">
            {" "}
            <PDFIcon className="file-view-image" />{" "}
            {attachmentsFile.map((each: any) => each.path)}
            <span onClick={removeFile} className="removeFile">
              <DeleteCross className="delete-cross-image" />
            </span>
          </div>
        )}

        {config?.messageTextArea ? (
          <div className="message-footer">
            <div className={`messageArea ${location.pathname === "/messagecenter" ? "textAreaWidth" : ""}`}>
              <Field
                component={TextFieldNew}
                type="textarea"
                name="message"
                clearField={attachmentsFile && attachmentsFile?.length > 0}
                placeholder={
                  attachmentsFile && attachmentsFile?.length > 0
                    ? "Message is disabled for file upload"
                    : "Type your message here"
                }
                disabled={attachmentsFile && attachmentsFile?.length > 0}
              />

              <span className="messageSend">
                {location.pathname === "/landing" ? "" : "Send"}
                <Button
                  disabled={
                    props?.invalid || props?.pristine || props?.submitting
                  }
                  type="submit"
                  color="outline-primary"
                >
                  <SendIcon className="send-image" />
                </Button>
              </span>
              {config?.messageUpload ? (
                <div className="attachDocs">
                  <Field
                    component={FileUploadWithoutViewer}
                    name="file"
                    type="file"
                    placeholder="Attach Document"
                    acceptedFormats="image/jpeg, image/png, image/gif, image/bmp, .pdf, .docx, .xlsx, .csv"
                    displayAccepedFormats={false}
                    allowMultiple={false}
                    maxSize={5242880}
                    noDrag={true}
                    onChange={setAttachmentsFile}
                    removeAllFiles={removeAllFiles}
                  />
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      <div className="fileViewerModalContainer">
        <Modal
          className=" mw-100 w-50 fileViewerModalWrapper messageCenterFileView"
          isOpen={viewFile}
          fade={false}
          toggle={() => setViewFile((prev) => !prev)}
        >
          <ModalHeader toggle={() => setViewFile((prev) => !prev)}>
            <Row className="customHeader modal-title">
              <Col>
                <div
                  className={`fileHeader ${readMore ? "expand" : "contract"}`}
                  onClick={() => setReadMore((prev) => !prev)}
                >
                  {downloadFile?.name}
                </div>
              </Col>
            </Row>
            <Row></Row>
          </ModalHeader>
          <ModalBody>
            <div className="TC_fileView">
              {downloadFile ? (
                // <FileViewer files={[downloadFile]} disableHeader={true} />
                <ReactFileViewer
                  fileDocument={downloadFile}
                />
              ) : <></>}
            </div>
          </ModalBody>
        </Modal>
      </div>
    </form>
  );
};

export default connect(
  (state: Record<string, unknown>, props: MessageFormProps) => {
    return {
      initialValues: {
        recipient:
          props?.conversation?.createdBy === props?.bankuserDetails?.userId
            ? props?.conversation?.sentTo
            : props?.conversation?.createdBy,
        subject: props?.conversation?.subject,
      },
      formValues: getFormValues("MessageForm")(state),
    };
  }
)(
  reduxForm<Record<string, unknown>, MessageFormProps>({
    form: "MessageForm",
    enableReinitialize: true,
    validate,
  })(MessageForm)
);
